import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FilePondModule, registerPlugin } from 'ngx-filepond';


import { BusinessInformationComponent } from '@teem/setting-module/business-information/business-information.component';
import { CardDetailModalComponent } from '@teem/setting-module/modals/card-detail-modal/card-detail-modal.component';
import { HyperpaySubscriptionModalComponent } from '@teem/setting-module/modals/hyperpay-subscription-modal/hyperpay-subscription-modal.component';
import { ContractModalComponent } from '@teem/setting-module/modals/contract-modal/contract-modal.component';
import { TapContractModalComponent } from '@teem/setting-module/modals/tap-contract-modal/tap-contract-modal.component';
import { TeemContractModalComponent } from '@teem/setting-module/modals/teem-contract-modal/teem-contract-modal.component';
import { OtpValidateModalComponent } from '@teem/payment-info/components/paylink-tab/modals/otp-validate-modal/otp-validate-modal.component';
import { TermsModalComponent } from '@teem/payment-info/components/paylink-tab/modals/terms-modal/terms-modal.component';
import { SubscriptionFormComponent } from '@teem/setting-module/forms/subscription-form/subscription-form.component';
import { AccountSettingComponent } from '@teem/setting-module/account-setting/account-setting.component';
import { HalalahTabComponent } from '@teem/payment-info/components/halalah-tab/halalah-tab.component';
import { StcpayTabComponent } from '@teem/payment-info/components/stcpay-tab/stcpay-tab.component';
import { TamaraTabComponent } from '@teem/payment-info/components/tamara-tab/tamara-tab.component';
import { PaypalTabComponent } from '@teem/payment-info/components/paypal-tab/paypal-tab.component';
import { StripeTabComponent } from '@teem/payment-info/components/stripe-tab/stripe-tab.component';
import { OpayTabComponent } from '@teem/payment-info/components/opay-tab/opay-tab.component';
import { OtoTabComponent } from '@teem/payment-info/components/oto-tab/oto-tab.component';
import { MomknTabComponent } from '@teem/payment-info/components/momkn-tab/momkn-tab.component';
import { HyperpayTabComponent } from '@teem/payment-info/components/hyperpay-tab/hyperpay-tab.component';
import { TapTabComponent } from '@teem/payment-info/components/tap-tab/tap-tab.component';
import { TapMerchantTabComponent } from '@teem/payment-info/components/tap-merchant-tab/tap-merchant-tab.component';
import { MyfatoorahTabComponent } from '@teem/payment-info/components/myfatoorah-tab/myfatoorah-tab.component';
import { MoyasarTabComponent } from '@teem/payment-info/components/moyasar-tab/moyasar-tab.component';
import { PaylinkTabComponent } from '@teem/payment-info/components/paylink-tab/paylink-tab.component';
import { HalaTabComponent } from '@teem/payment-info/components/hala-tab/hala-tab.component';
import { ManagePlanComponent } from '@teem/setting-module/manage-plan/manage-plan.component';
import { BankInfoComponent } from '@teem/setting-module/bank-info/bank-info.component';
import { MerchantInfoComponent } from '@teem/payment-info/merchant-info.component';
import { SettingRoutingModule } from '@teem/setting-module/setting-routing.module';
import { SettingComponent } from '@teem/setting-module/setting.component';
import { CoreModule } from '@teem/core/core.module';
import { SharedModule } from '@teem/shared/shared.module';
import { ApplePayComponent } from '@teem/setting-module/apple-pay/apple-pay.component';
import { WhatsappNotificationComponent } from '@teem/setting-module/whatsapp-notification/whatsapp-notification.component';
import { CareemTabComponent } from '@teem/payment-info/components/careem-tab/careem-tab.component';
import { MrsoolTabComponent } from '@teem/payment-info/components/mrsool-tab/mrsool-tab.component';

// Import filepond plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type';
import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation/dist/filepond-plugin-image-exif-orientation';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview';
import FilePondPluginImageCrop from 'filepond-plugin-image-crop/dist/filepond-plugin-image-crop';
import FilePondPluginImageResize from 'filepond-plugin-image-resize/dist/filepond-plugin-image-resize';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform/dist/filepond-plugin-image-transform';
import FilePondPluginImageEdit from 'filepond-plugin-image-edit/dist/filepond-plugin-image-edit';
import { WalletComponent } from '@teem/setting-module/wallet/wallet.component';
import { AddFundModelComponent } from './modals/add-fund-model/add-fund-model.component';
import { ProfileModule } from '../profile/profile.module';
import { MyfatoorahContractModalComponent } from '@teem/setting-module/modals/myfatoorah-contract-modal/myfatoorah-contract-modal.component';
import { NewtapContractModelComponent } from './modals/newtap-contract-model/newtap-contract-model.component';


registerPlugin(
  FilePondPluginFileValidateType,
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginImageCrop,
  FilePondPluginImageResize,
  FilePondPluginImageTransform,
  FilePondPluginImageEdit
);

@NgModule({
  declarations: [
    SettingComponent,
    AccountSettingComponent,
    BusinessInformationComponent,
    MerchantInfoComponent,
    ManagePlanComponent,
    SubscriptionFormComponent,
    CardDetailModalComponent,
    ContractModalComponent,
    TapContractModalComponent,
    TeemContractModalComponent,
    OtpValidateModalComponent,
    TermsModalComponent,
    HyperpaySubscriptionModalComponent,
    StcpayTabComponent,
    TamaraTabComponent,
    HalalahTabComponent,
    HalaTabComponent,
    PaypalTabComponent,
    StripeTabComponent,
    OpayTabComponent,
    OtoTabComponent,
    BankInfoComponent,
    MomknTabComponent,
    PaylinkTabComponent,
    HyperpayTabComponent,
    TapTabComponent,
    TapMerchantTabComponent,
    MyfatoorahTabComponent,
    MoyasarTabComponent,
    ApplePayComponent,
    WhatsappNotificationComponent,
    CareemTabComponent,
    WalletComponent,
    AddFundModelComponent,
    MrsoolTabComponent,
    MyfatoorahContractModalComponent,
    NewtapContractModelComponent
  ],
  entryComponents: [
    CardDetailModalComponent,
    AddFundModelComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    FilePondModule,
    CoreModule,
    ReactiveFormsModule,
    SettingRoutingModule,
    SharedModule,
    ProfileModule
  ]
})
export class SettingModule { }
